import { render, staticRenderFns } from "./UsersActivity.vue?vue&type=template&id=4bbcdee4&scoped=true"
import script from "./UsersActivity.vue?vue&type=script&lang=js"
export * from "./UsersActivity.vue?vue&type=script&lang=js"
import style0 from "./UsersActivity.vue?vue&type=style&index=0&id=4bbcdee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbcdee4",
  null
  
)

export default component.exports